import React from 'react'

export default function About (){
    return(
        <div className="about">
            <p>About Page</p>
            <p>Developers: Roberto Lozano and Alvin Ho</p>
        </div>
    )
}